import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "form"]

  connect() {
    this.inputTarget.focus()
  }

  checkLength() {
    if (this.inputTarget.value.length === 6) {
      this.formTarget.requestSubmit()
    }
  }
}
